var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-hint"},[_c('div',{staticClass:"hint-cont"},[_c('div',{staticClass:"hint-tip"},[(_vm.icon)?_c('div',{staticClass:"hint-icon"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.iconSrc,"alt":""}})]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hint-msg"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }